import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { IconButton } from '../IconButton';
import { cn } from '@/service/utils/cn';

type TMenuButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    icon: string;
    label?: ReactNode | string;
    className?: string;
    onClick?: () => void;
};

export const MenuButton = ({ className, icon, label, onClick }: TMenuButtonProps) => {
    return (
        <IconButton
            icon={
                <div className="mr-3 flex h-9 w-9 items-center justify-center rounded-3xl bg-ash object-contain p-2 dark:bg-dark-3">
                    <img src={`/icon/${icon}.svg`} alt={icon} />
                </div>
            }
            label={label}
            className={cn(
                'tx-large-medium my-4 w-full !justify-start rounded-2xl text-gray-1 hover:bg-ash dark:text-white  hover:dark:bg-blue-dark',
                className
            )}
            onClick={onClick}
        />
    );
};
